import React from 'react'
import { Select, InputNumber } from 'antd'
import { IBestDataset } from '../../../../../../types/analytics'
import { advancedAnalyticsMonthOptions } from '../../../../ResultPanel/Plot/MonthOptions'
import { Label } from "../../../../../common/Label/Label"
import styles from '../../../../ResultPanel/Style/LayoutPanel.module.scss'

interface ScatterTableAdditionalInputProps {
  datasets: IBestDataset[]
  categories: string[]
  datasetY: string | null
  onDatasetYChange: (value: string) => void
  isChangeDatasetY: boolean
  variablesY: any[]
  tempVariableY: any
  onVariableYChange: (value: any) => void
  intervalX: number
  onChangeIntervalX: (value: number | null) => void
  intervalY: number
  onChangeIntervalY: (value: number | null) => void
  month: any
  onMonthChange: (value: any) => void
  isLoading: boolean
  hasError: boolean
  isOfflineDataset: boolean
}

export default function ScatterTableAdditionalInput({
  datasets,
  categories,
  datasetY,
  onDatasetYChange,
  isChangeDatasetY,
  variablesY,
  tempVariableY,
  onVariableYChange,
  intervalX,
  onChangeIntervalX,
  intervalY,
  onChangeIntervalY,
  month,
  onMonthChange,
  isLoading,
  isOfflineDataset
}: ScatterTableAdditionalInputProps) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      padding: '16px',
      gap: '12px',
      height: '100%'
    }}>
      <Label label="Dataset Y" className={styles.actionItem}>
        <Select
          id="Analytics-ScatterTable-DatasetY_Input"
          value={datasetY}
          size="small"
          style={{ width: '100%' }}
          onChange={onDatasetYChange}
          disabled={isOfflineDataset ||isChangeDatasetY || isLoading }
        >
          {categories.map((category: string) => (
            <Select.OptGroup key={category} label={category}>
              {datasets
                .filter((item) => item.label === category)
                .map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.value}
                  </Select.Option>
                ))}
            </Select.OptGroup>
          ))}
        </Select>
      </Label>

      <Label label="Variable Y" className={styles.actionItem}>
        <Select
          id="Analytics-ScatterTable-VariableY_Input"
          value={tempVariableY?.Index ? tempVariableY.Index : 0}
          size="small"
          style={{ width: '100%' }}
          onChange={onVariableYChange}
          disabled={isOfflineDataset ||isLoading }
        >
          {variablesY
            .filter((item) => item.Name !== 'Time')
            .map((item) => (
              <Select.Option key={item.Index} value={item.Index}>
                {item.Name}
              </Select.Option>
            ))}
        </Select>
      </Label>

      <Label label="Number of Intervals X" className={styles.actionItem}>
        <InputNumber
          id="Analytics-ScatterTable-IntervalsX_Input"
          size="small"
          min={1}
          max={40}
          value={intervalX}
          style={{ width: '100%' }}
          onChange={onChangeIntervalX}
          disabled={isOfflineDataset ||isLoading }
        />
      </Label>

      <Label label="Number of Intervals Y" className={styles.actionItem}>
        <InputNumber
          id="Analytics-ScatterTable-IntervalsY_Input"
          size="small"
          min={1}
          max={40}
          style={{ width: '100%' }}
          onChange={onChangeIntervalY}
          value={intervalY}
          disabled={isOfflineDataset ||isLoading }
        />
      </Label>

      <Label label="Month" className={styles.actionItem}>
        <Select
          id="Analytics-ScatterTable-Month_Input"
          size="small"
          style={{ width: '100%' }}
          onChange={onMonthChange}
          options={advancedAnalyticsMonthOptions}
          disabled={isOfflineDataset ||isLoading }
          value={month}
          />
      </Label>

      <div style={{ flex: 1 }} />
    </div>
  )
}
